

class SourceItem {

    constructor() {
        this.sourceTxt = "";
        this.sourceImg = "default.png";
        this.hasExternalUrl = false
        this.sourceIndex = -1
        this.htmlRef=null
    }

    getAsJson = () => {
        let obj = {}
        obj.sourceTxt = this.sourceTxt
        obj.sourceIndex = this.sourceIndex
        obj.sourceImg = this.sourceImg
        obj.hasExternalUrl = this.hasExternalUrl
        return obj
    }


    initFromJson = (obj) => {
        this.sourceTxt = obj.sourceTxt
        this.sourceIndex = obj.sourceIndex
        this.sourceImg = obj.sourceImg
        this.hasExternalUrl = obj.hasExternalUrl
    }
}

export default SourceItem